import {
  START_FETCHING_ORDER_HISTORY,
  SUCCESS_FETCHING_ORDER_HISTORY,
  ERROR_FETCHING_ORDER_HISTORY,
  START_FETCHING_ORDER_PERIODS,
  SUCCESS_FETCHING_ORDER_PERIODS,
  START_FETCHING_MORE_ORDER_PERIODS,
  ERROR_FETCHING_MORE_ORDER_PERIODS,
  SUCCESS_FETCHING_MORE_ORDER_PERIODS,
  ERROR_FETCHING_ORDER_PERIODS,
  START_FETCHING_HISTORY_ORDER_DETAILS,
  SUCCESS_FETCHING_HISTORY_ORDER_DETAILS,
  ERROR_FETCHING_HISTORY_ORDER_DETAILS,
  START_DOWNLOADING_INVOICE,
  DOWNLOADING_INVOICE_SUCCESS,
  DOWNLOADING_INVOICE_ERROR,
  START_DOWNLOADING_PAYMENT_SLIP,
  DOWNLOADING_PAYMENT_SLIP_SUCCESS,
  DOWNLOADING_PAYMENT_SLIP_ERROR,
  START_FETCHING_NOTA_FISCAL_LINK,
  FETCHING_NOTA_FISCAL_LINK_SUCCESS,
  FETCHING_NOTA_FISCAL_LINK_ERROR,
} from '@app/actions/order-history';

const getPeriodId = (periodStart, periodEnd, dealerId) => {
  if (dealerId) {
    return `${periodStart}|${periodEnd}@${dealerId}`;
  }

  return `${periodStart}|${periodEnd}`;
};

const transformOrderListIntoDict = (state, orders) => {
  const ordersIntoDict = (accum, order) => {
    const id = order.orderId;

    return {
      ...accum,
      [id]: {
        ...order,
        id,
        isFetchingDetails: false,
      },
    };
  };

  return orders.reduce(ordersIntoDict, state);
};

const transformPeriodListIntoDict = (state, periods, dealerId) => {
  const periodsIntoDict = (accum, period) => {
    const periodId = getPeriodId(period.periodStartTime, period.periodEndTime, dealerId);

    return {
      ...accum,
      [periodId]: {
        ...period,
        id: periodId,
        isFetchingOrders: false,
        orders: {},
      },
    };
  };

  return periods.reduce(periodsIntoDict, state);
};

const order = (state, action) => {
  switch (action.type) {
    case START_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        isFetchingDetails: true,
      };

    case SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        details: action.orderDetails,
        isFetchingDetails: false,
      };

    case ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        isFetchingDetails: false,
      };

    default:
      return state;
  }
};

const period = (state, action) => {
  switch (action.type) {
    case START_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        isFetchingOrders: true,
      };

    case SUCCESS_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        orders: transformOrderListIntoDict(state.orders, action.orders.list),
        nextBatchHref: action.orders.nextBatchHref,
        isFetchingOrders: false,
      };

    case ERROR_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        isFetchingOrders: false,
      };

    case START_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.orderId]: order(state.orders[action.orderId], action),
        },
      };

    case SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.orderId]: order(state.orders[action.orderId], action),
        },
      };

    case ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.orderId]: order(state.orders[action.orderId], action),
        },
      };
    default:
      return state;
  }
};

const initialState = {
  isFetchingPeriods: false,
  isFetchingMorePeriods: false,
  isDownloading: false,
  fileError: false,
  fileErrorCode: null,
  nextBatchHref: null,
  periods: {},
};

const orderHistory = (state = initialState, action) => {
  switch (action.type) {
    /* ORDER HISTORY PERIODS */
    case START_FETCHING_ORDER_PERIODS:
      return {
        ...state,
        isFetchingPeriods: true,
      };

    case SUCCESS_FETCHING_ORDER_PERIODS:
      return {
        ...state,
        periods: transformPeriodListIntoDict({}, action.periods, action.dealerId),
        nextBatchHref: action.nextBatchHref,
        isFetchingPeriods: false,
      };

    case START_FETCHING_MORE_ORDER_PERIODS:
      return {
        ...state,
        isFetchingMorePeriods: true,
      };

    case ERROR_FETCHING_MORE_ORDER_PERIODS:
      return {
        ...state,
        isFetchingMorePeriods: false,
      };

    case SUCCESS_FETCHING_MORE_ORDER_PERIODS:
      return {
        ...state,
        periods: transformPeriodListIntoDict(state.periods, action.periods, action.dealerId),
        nextBatchHref: action.nextBatchHref,
        isFetchingMorePeriods: false,
      };

    case ERROR_FETCHING_ORDER_PERIODS:
      return {
        ...state,
        isFetchingPeriods: false,
      };

    /* ORDER HISTORY FOR A PARTICULAR PERIOD */
    case START_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    case SUCCESS_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    case ERROR_FETCHING_ORDER_HISTORY:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    /* HISTORY ORDER DETAILS */
    case START_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    case SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    case ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return {
        ...state,
        periods: {
          ...state.periods,
          [action.periodId]: period(state.periods[action.periodId], action),
        },
      };

    case START_DOWNLOADING_INVOICE:
    case START_FETCHING_NOTA_FISCAL_LINK:
    case START_DOWNLOADING_PAYMENT_SLIP:
      return {
        ...state,
        fileError: false,
        fileErrorCode: null,
        isDownloading: true,
      };

    case DOWNLOADING_INVOICE_SUCCESS:
    case FETCHING_NOTA_FISCAL_LINK_SUCCESS:
    case DOWNLOADING_PAYMENT_SLIP_SUCCESS:
      return {
        ...state,
        fileError: false,
        fileErrorCode: null,
        isDownloading: false,
      };

    case DOWNLOADING_INVOICE_ERROR:
    case FETCHING_NOTA_FISCAL_LINK_ERROR:
    case DOWNLOADING_PAYMENT_SLIP_ERROR:
      return {
        ...state,
        fileError: true,
        fileErrorCode: action.errorCode,
        isDownloading: false,
      };

    default:
      return state;
  }
};

export default orderHistory;



// WEBPACK FOOTER //
// ./src/reducer/order-history.js